var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.91499C13.09 3.63499 14.76 2.825 16.5 2.825C19.58 2.825 22 5.245 22 8.325C22 12.1019 18.6056 15.1799 13.4626 19.8435L13.45 19.855L12 21.175L10.55 19.865L10.5105 19.8291C5.38269 15.1692 2 12.0953 2 8.325C2 5.245 4.42004 2.825 7.5 2.825C9.23999 2.825 10.91 3.63499 12 4.91499ZM12 18.475L12.1 18.375C16.86 14.065 20 11.215 20 8.325C20 6.325 18.5 4.825 16.5 4.825C14.96 4.825 13.46 5.81499 12.9399 7.185H11.0699C10.54 5.81499 9.04004 4.825 7.5 4.825C5.5 4.825 4 6.325 4 8.325C4 11.215 7.14001 14.065 11.9 18.375L12 18.475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.81dcebd7.svg";
export { ForwardRef as ReactComponent };